<template>
  <div>
    <form ref="form">
      <input
        ref="input"
        :accept="accept || 'image/png,image/gif,image/jpeg,image/webp, .gif,.jpg,.jpeg,.png,.webp'"
        type="file"
        style="display: none"
        @change="processFile($event)"
      >
    </form>
    <simple-snackbar
      :open.sync="fileTooBig"
      color="primary"
      message-prop="Sorry, the image you tried to upload is too large"
    />
  </div>
</template>

<script>

import SimpleSnackbar from './snackbars/simple-snackbar'

export default {
  name:'hidden-file-input',
  components: {
    SimpleSnackbar,
  },
  props: {
    accept: String,
    maxFileSizeMb: String,
  },
  data() {
    return {
      fileTooBig: false,
    }
  },
  methods: {
    processFile({ target: { files }}) {
      if (files[0].size / 1000000 > this.maxFileSizeMb) {
        this.fileTooBig = true
      }
      else {
        this.$emit('file', files[0])
      }
      this.$refs.form.reset()
    },
  },
}
</script>

<style scoped>
</style>
